
const digest = '80e337f1cd1efb88afbee4814d23afd6d7c7ba6cdee22127cc4d55a291aa1aec';
const classes = {"wrapper":"_wrapper_1htmr_1","heavy":"_heavy_1htmr_5","workplace":"_workplace_1htmr_9"};
const css = `._wrapper_1htmr_1 {
  font-size: 14px;
}

._heavy_1htmr_5 {
  font-weight: 500;
}

._workplace_1htmr_9 {
  font-size: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  